import styled from '@emotion/styled';
import { Stack } from '@hotjar/hotsauce';

export const AskLimitsCardStyles = {
  CardBody: styled(Stack)`
    align-items: center;
  `,
};
